export default __webpack_public_path__ + "static/media/ellipsis.d4931dec.svg";